<template>
  <div class="products">
    <h1>This is Products page</h1>
  </div>
</template>

<script>

export default {
  name: 'Products'
}
</script>

<style scoped lang="scss">

.products {
  height: 86.6vh;
  display: flex;
  flex-direction: column;
  margin: auto auto;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
